<template>
  <footer>
    <div class="text-center container text-uppercase">
      *Terms apply. Ends 6/30/27. Submit by 6/30/27. Visit <a href="https://pgmarketbasket.com/"
        target="_blank" aria-label="PG Market Basket website (opens in new tab)">https://www.PGMarketBasket.com</a> for full details and Privacy Policy. © {{ new Date().getFullYear() }} Procter & Gamble
    </div>
    <div class="footer-wrapper">
          <div class="container">
            <ul class="list-inline mb-3" id="footer-nav">
              <li class="list-inline-item p">
                <a aria-label="Do Not Sell or Share My Personal Information / Opt-Out of
                  Targeted Advertising"
                  href="javascript:void(0)"
                  onclick="Optanon.ToggleInfoDisplay();"
                  >Do Not Sell or Share My Personal Information / Opt-Out of
                  Targeted Advertising</a
                >
              </li>
              <li class="list-inline-item">
                <a aria-label="Terms & Conditions"
                  rel="noopener noreferrer"
                  href="http://www.pg.com/en_US/terms_conditions/index.shtml"
                  target="_blank"
                  >Terms & Conditions</a
                >
              </li>
               <li class="list-inline-item">
                <a aria-label="Accessibility Statement"
                  rel="noopener noreferrer"
                  href="https://accessibility.pg.com/en-us"
                  target="_blank"
                  >Accessibility Statement</a
                >
              </li>
              <li class="list-inline-item">
                <a aria-label="Contact Us"
                  href="http://www.pg.com/en_US/contact_us/index.shtml"
                  target="_blank"
                  >Contact Us</a
                >
              </li>
              <li class="list-inline-item">
                <a aria-label="Privacy"
                  rel="noopener noreferrer"
                  href="https://privacypolicy.pg.com/en/#statePrivacyNotice"
                  target="_blank"
                  >Privacy</a
                >
              </li>
              <li class="list-inline-item">
                <a aria-label="Consumer Health Data Privacy Policy" href="https://privacypolicy.pg.com/CHD-en" target="_blank"
                  >Consumer Health Data Privacy Policy</a
                >
              </li>
              <li class="list-inline-item">
                <a aria-label="Your Privacy Choices" href="https://preferencecenter.pg.com/en-us/" target="_blank"
                  >Your Privacy Choices <img src="https://snippcheck.blob.core.windows.net/files/PG_2008946_MarketBasketEvergreen/privacyoptions.png" alt="Your Privacy Choices" class="img-fluid"></a
                >
              </li>
            </ul>
            <p>NOTICE: We may sell your sensitive personal data.</p>
            <p class="mb-0">
              © {{ new Date().getFullYear() }} Procter & Gamble. All rights
                reserved.
            </p>
          </div>
        </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;

    // // Append the script to the body
    // document.body.appendChild(script);
  },
};
</script>
